import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowUpRight, ArrowLeft } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { GoldButton } from "@/components/common/Buttons";
import { SECTORS } from "@/lib/content";
import { useSeo } from "@/lib/seo";

const KW = {
  "enseignes-signaletique": "rachat entreprise enseigne, cession entreprise enseigne, repreneur entreprise signalétique",
  "communication-visuelle": "rachat entreprise communication visuelle, cession entreprise communication visuelle",
  "impression-numerique": "reprise imprimerie numérique, rachat imprimerie, cession imprimerie",
  "marquage-adhesif-covering": "entreprise covering à vendre, rachat société covering, rachat entreprise marquage adhésif",
  "smart-glass": "rachat entreprise smart glass, cession entreprise smart glass",
  "metallerie-serrurerie": "cession entreprise métallerie, rachat entreprise métallerie, reprise serrurerie métallerie",
};

export default function AcquisitionSector() {
  const { slug } = useParams();
  const sector = SECTORS.find((s) => s.slug === slug);
  useSeo({
    title: sector ? `${sector.title} — Rachat & reprise d'entreprise | Losta Group` : "Secteur | Losta Group",
    description: sector ? `${sector.short} Losta Group étudie le rachat et la reprise d'entreprises de ${sector.title.toLowerCase()} en France et en Suisse. ${KW[slug] || ""}` : "",
    path: `/acquisitions/${slug}`,
  });

  if (!sector) return <Navigate to="/acquisitions" replace />;

  return (
    <>
      <PageHero
        eyebrow={`Secteur ${sector.n}`}
        lines={[sector.title]}
        sub={sector.short}
        image={sector.img}
      >
        <GoldButton to="/ceder-votre-entreprise" testid="sector-cta">
          Céder une entreprise de ce secteur <ArrowUpRight className="h-4 w-4" />
        </GoldButton>
      </PageHero>

      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <Link to="/acquisitions" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-gold mb-10 transition-colors">
            <ArrowLeft className="h-4 w-4" /> Tous les secteurs
          </Link>
          <SectionHeading eyebrow="Activités concernées" lines={["Les expertises", "que nous fédérons."]} className="mb-10" />
          <div className="flex flex-wrap gap-3">
            {sector.items.map((it, i) => (
              <Reveal key={it} delay={(i % 6) * 0.03}>
                <span className="rounded-full border border-white/10 bg-white/[0.02] px-5 py-2.5 text-sm text-slate-200 hover:border-[var(--gold)]/40 hover:text-gold transition-all">
                  {it}
                </span>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-16 rounded-2xl border border-white/10 card-lux p-8 sm:p-12 radial-gold">
              <h3 className="font-serif text-3xl text-white max-w-2xl">Vous dirigez une entreprise dans ce secteur et préparez sa transmission ?</h3>
              <p className="mt-4 max-w-2xl text-base text-[var(--txt-2)] font-light">
                Losta Group étudie chaque projet individuellement, dans la plus stricte confidentialité. Premier échange sans engagement.
              </p>
              <div className="mt-8"><GoldButton to="/ceder-votre-entreprise" testid="sector-bottom-cta">Parler de mon entreprise</GoldButton></div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
